import { node } from 'prop-types'
import { Paper as MUIPaper } from '@mui/material'

const Paper = ({ children }) => <MUIPaper>{children}</MUIPaper>

export default Paper

Paper.propTypes = {
  children: node.isRequired,
}
